import {
  AlertTriangle,
  ArrowRight,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Command,
  CreditCard,
  File,
  FileText,
  HelpCircle,
  Image,
  Laptop,
  Loader2,
  Moon,
  MoreVertical,
  Pizza,
  Plus,
  Search,
  Settings,
  SunMedium,
  Trash,
  User,
  X,
} from "lucide-react"

export const Icons = {
  logo: Command,
  close: X,
  spinner: Loader2,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  trash: Trash,
  post: FileText,
  page: File,
  media: Image,
  settings: Settings,
  billing: CreditCard,
  ellipsis: MoreVertical,
  add: Plus,
  warning: AlertTriangle,
  user: User,
  arrowRight: ArrowRight,
  help: HelpCircle,
  pizza: Pizza,
  sun: SunMedium,
  moon: Moon,
  laptop: Laptop,
  search: Search,
  chevronDown: ChevronDown,
  loadingIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 -960 960 960"
      >
        <path
          fill="#fff"
          d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80z"
        />
      </svg>
    )
  },
  emailIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="20"
        fill="none"
        viewBox="0 0 19 20"
      >
        <path
          stroke="#939393"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.734 4.063H3.266c-.82 0-1.485.664-1.485 1.484v8.906c0 .82.665 1.485 1.485 1.485h12.468c.82 0 1.485-.665 1.485-1.485V5.547c0-.82-.665-1.484-1.485-1.484z"
        />
        <path
          stroke="#939393"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.156 6.438L9.5 10.593l5.344-4.156"
        />
      </svg>
    )
  },
  passwordIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="20"
        fill="none"
        viewBox="0 0 19 20"
      >
        <path
          stroke="#939393"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5.938 7.031V5.844A3.563 3.563 0 019.5 2.28v0a3.563 3.563 0 013.563 3.563V7.03m-10.094 0a.594.594 0 00-.594.594v8.016c0 1.122.956 2.078 2.078 2.078h10.094c1.122 0 2.078-.91 2.078-2.032V7.625a.594.594 0 00-.594-.594H2.97z"
        />
      </svg>
    )
  },
  nameIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="20"
        fill="none"
        viewBox="0 0 19 20"
      >
        <path
          stroke="#939393"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12.884 5.692c-.151 2.034-1.693 3.693-3.385 3.693-1.692 0-3.237-1.659-3.385-3.693C5.961 3.577 7.461 2 9.5 2s3.538 1.615 3.385 3.692z"
        />
        <path
          stroke="#939393"
          strokeMiterlimit="10"
          d="M9.5 11.846c-3.346 0-6.742 1.846-7.37 5.33-.077.42.161.824.601.824H16.27c.44 0 .677-.404.601-.823-.628-3.485-4.025-5.331-7.37-5.331z"
        />
      </svg>
    )
  },
  couponIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="16"
        fill="none"
        viewBox="0 0 21 16"
      >
        <mask
          id="mask0_291_396"
          style={{
            maskType: "luminance",
          }}
          width="21"
          height="16"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M20.5.488H.5v15.024h20V.488z" />
        </mask>
        <g mask="url(#mask0_291_396)">
          <path
            fill="#111"
            d="M18.4 15.488H2.58a2.062 2.062 0 01-2.082-2.081V9.826h.833c.999 0 1.79-.833 1.79-1.832 0-1-.791-1.79-1.79-1.832H.498v-3.58C.498 1.416 1.414.5 2.58.5H18.4c1.166 0 2.082.916 2.082 2.082v3.58h-.832c-1 0-1.832.833-1.832 1.832 0 1 .833 1.832 1.832 1.832h.832v3.58a2.062 2.062 0 01-2.081 2.082zM2.164 11.367v2.04c0 .208.209.416.417.416H18.4a.448.448 0 00.416-.416v-2.04c-1.498-.375-2.664-1.75-2.664-3.373a3.477 3.477 0 012.665-3.372v-2.04a.448.448 0 00-.417-.417H2.58a.448.448 0 00-.417.417v2.04a3.486 3.486 0 012.623 3.372 3.485 3.485 0 01-2.623 3.373z"
          />
        </g>
      </svg>
    )
  },
  checkIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="12"
        fill="none"
        viewBox="0 0 14 12"
      >
        <path
          fill="#fff"
          d="M12.117.549l1.882 1.93-9.185 8.965-4.817-4.6 1.862-1.95 2.934 2.803L12.117.549z"
        />
      </svg>
    )
  },
  editIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
      >
        <g clipPath="url(#clip0_2035_17359)">
          <mask
            id="mask0_2035_17359"
            style={{
              maskType: "luminance",
            }}
            width="15"
            height="15"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M14.898 0H0v14.92h14.898V0z" />
          </mask>
          <g mask="url(#mask0_2035_17359)">
            <path
              fill="#ADADAD"
              d="M13.885.182a.588.588 0 11.83.831l-8.31 8.31a.588.588 0 11-.83-.83l8.31-8.31zm-.172 6.096a.588.588 0 111.175 0v6.465c0 1.19-.965 2.155-2.155 2.155H2.155A2.155 2.155 0 010 12.743V2.165C0 .975.965.01 2.155.01h6.269a.588.588 0 110 1.175h-6.27a.98.98 0 00-.979.98v10.578a.98.98 0 00.98.98h10.578a.98.98 0 00.98-.98V6.278z"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_2035_17359">
            <path fill="#fff" d="M0 0H14.898V14.92H0z" />
          </clipPath>
        </defs>
      </svg>
    )
  },
  closeButton: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        fill="none"
        viewBox="0 0 12 12"
      >
        <path
          stroke="#111"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11 11L1 1m10 0L1 11"
        />
      </svg>
    )
  },
  prevIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="31"
        fill="none"
        viewBox="0 0 17 31"
      >
        <path stroke="#2F6132" d="M15.5 30L1 15.5 15.5 1" />
      </svg>
    )
  },
  nextIcon: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="31"
        fill="none"
        viewBox="0 0 17 31"
      >
        <path stroke="#2F6132" d="M1 1l14.5 14.5L1 30" />
      </svg>
    )
  },
  FreeShipping: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="21"
        fill="none"
        viewBox="0 0 33 21"
      >
        <path
          fill="#2F2F2F"
          d="M23.422 17.97h-5.5a.449.449 0 110-.895h5.5a.449.449 0 110 .895zM31.549 17.97h-2.221a.449.449 0 110-.895h2.22a.552.552 0 00.554-.55V9.852a.868.868 0 00-.157-.497l-5.018-7.13a1 1 0 00-.818-.423H5.325a.449.449 0 110-.896h20.783c.618 0 1.2.301 1.554.806l5.017 7.13c.21.297.32.646.32 1.01v6.672a1.448 1.448 0 01-1.45 1.446zM12.017 17.97H9.783a1.489 1.489 0 01-1.492-1.483V11.15c0-.922.755-1.672 1.68-1.672h4.457a.449.449 0 110 .895H9.972a.781.781 0 00-.782.778v5.336c0 .325.266.59.593.59h2.234c.248 0 .45.2.45.447a.448.448 0 01-.45.445z"
        />
        <path
          fill="#2F2F2F"
          d="M30.439 10.291h-7.016c-.249 0-.45-.2-.45-.447V3.296c0-.247.201-.447.45-.447.248 0 .45.2.45.447v6.101h6.566c.248 0 .45.2.45.448a.448.448 0 01-.45.446zM13.724 4.901H.45c-.249 0-.45-.2-.45-.446 0-.247.201-.448.45-.448h13.274c.249 0 .45.2.45.448a.45.45 0 01-.45.446zM13.724 7.554H5.975a.449.449 0 110-.895h7.748a.449.449 0 11.001.895zM14.969 20.907c-1.876 0-3.403-1.518-3.403-3.384 0-1.867 1.526-3.385 3.403-3.385s3.402 1.518 3.402 3.385c0 1.866-1.525 3.384-3.402 3.384zm0-5.874a2.5 2.5 0 00-2.504 2.49 2.5 2.5 0 002.504 2.491 2.5 2.5 0 002.504-2.49 2.5 2.5 0 00-2.504-2.49zM26.375 20.907c-1.875 0-3.402-1.518-3.402-3.384 0-1.867 1.525-3.385 3.402-3.385 1.877 0 3.402 1.518 3.402 3.385 0 1.866-1.526 3.384-3.402 3.384zm0-5.874a2.5 2.5 0 00-2.504 2.49 2.5 2.5 0 002.504 2.491 2.5 2.5 0 002.504-2.49 2.5 2.5 0 00-2.504-2.49z"
        />
      </svg>
    )
  },
  LifetimeWarranty: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="30"
        fill="none"
        viewBox="0 0 26 30"
      >
        <path
          fill="#2F2F2F"
          d="M21.981 4.09a.483.483 0 01-.484-.481V2.328c0-.267.217-.482.484-.482.268 0 .485.215.485.482v1.28a.483.483 0 01-.485.483zM25.516 6.49h-1.288a.483.483 0 110-.963h1.288a.483.483 0 110 .964zM11.357 17.573a.48.48 0 01-.336-.135L7.538 14.11a.48.48 0 01-.013-.681.486.486 0 01.685-.014l3.146 3.006 4.524-4.395a.487.487 0 01.685.008.48.48 0 01-.008.682l-4.86 4.722a.495.495 0 01-.34.136zM23.7 4.78a.48.48 0 01-.343-.823l.991-.984a.487.487 0 01.686 0 .48.48 0 010 .682l-.99.985a.484.484 0 01-.343.14z"
        />
        <path
          fill="#2F2F2F"
          d="M11.339 29.104a.485.485 0 01-.267-.08l-1.084-.71c-.129-.084-1.291-.846-2.658-1.756a.48.48 0 01-.133-.668.485.485 0 01.672-.133c1.363.909 2.523 1.67 2.651 1.753l.819.536.818-.536c.554-.363 5.433-3.567 7.1-4.793 1.535-1.129 2.45-3.147 2.45-5.402V6.131c-5.784-1.272-9.352-3.614-10.368-4.35-1.016.736-4.584 3.078-10.37 4.35v11.184c0 2.253.917 4.273 2.451 5.402.408.3 1.051.749 1.91 1.334.22.15.277.45.126.67a.486.486 0 01-.673.125 72.827 72.827 0 01-1.939-1.354C1.064 22.183 0 19.874 0 17.316V5.831c0-.278.2-.523.473-.58C6.963 3.881 10.607 1.133 11.001.825a.543.543 0 01.672 0c.393.308 4.04 3.056 10.528 4.424a.596.596 0 01.473.58v11.484c0 2.558-1.063 4.867-2.844 6.176-1.688 1.24-6.588 4.458-7.14 4.82l-1.087.714a.46.46 0 01-.264.08z"
        />
        <path
          fill="#2F2F2F"
          d="M11.338 26.639a.485.485 0 01-.266-.08c-1.832-1.2-5.65-3.734-6.997-4.723-1.254-.922-2.004-2.612-2.004-4.52V7.458c0-.27.184-.504.447-.573 4.003-1.04 6.85-2.527 8.532-3.589a.54.54 0 01.582 0c1.683 1.062 4.529 2.547 8.53 3.589a.595.595 0 01.447.573v2.762a.483.483 0 01-.484.481.483.483 0 01-.484-.481V7.745c-3.806-1.022-6.577-2.43-8.3-3.492-1.724 1.061-4.496 2.47-8.3 3.492v9.569c0 1.604.602 3.004 1.612 3.745 1.267.933 4.782 3.268 6.688 4.519 1.103-.725 5.234-3.45 6.688-4.518 1.009-.742 1.612-2.143 1.612-3.746V14.25c0-.266.216-.482.484-.482s.484.216.484.482v3.064c0 1.908-.75 3.597-2.005 4.521-1.67 1.227-6.78 4.581-6.997 4.723a.497.497 0 01-.268.081z"
        />
      </svg>
    )
  },
}
